import { alpha } from '@mui/material/styles';

/**
 * MuiButtonBase — the underlying interaction primitive every MUI button
 * inherits from (Button, IconButton, ToggleButton, MenuItem…).
 *
 * Sets the focus ring for keyboard navigation and disables the ripple
 * globally. Both defaults apply everywhere; component-specific styling
 * belongs in the individual overrides (Button.jsx, IconButton.jsx, etc.).
 */
export const buttonBaseCustomizations = {
  MuiButtonBase: {
    defaultProps: {
      disableTouchRipple: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        boxSizing: 'border-box',
        transition: 'all 100ms ease-in',
        '&:focus-visible': {
          outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          outlineOffset: '2px',
        },
      }),
    },
  },
};
